<template>
    <modal id="hotel-floor-assignment-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('floor_assignment')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/floor-assignment`'
            @submit.prevent="submitData"
        >
            <app-form-group-selectable
                type="select"
                :label="$t('hotel')"
                list-value-field="name"
                v-model="formData.hotel_id"
                :required="true"
                :chooseLabel="$t('hotel')"
                :error-message="$errorMessage(errors, 'hotel_id')"
                :fetch-url="`${TENANT_BASE_URL}selectable/hotel/list`"
            />
            <app-form-group-selectable
                type="select"
                :label="$t('floor')"
                list-value-field="floor"
                list-value-id="floor"
                v-model="formData.floor"
                :required="true"
                :chooseLabel="$t('floor')"
                :error-message="$errorMessage(errors, 'floor')"
                :fetch-url="room_url"
            />
            <app-form-group
                type="date"
                :label="$t('work_date')"
                v-model="formData.work_date"
                :required="true"
                :placeholder="$placeholder('work_date')"
                :error-message="$errorMessage(errors, 'work_date')"
            />
            <app-form-group-selectable
                type="multi-select"
                :label="$t('employees')"
                list-value-field="employee_name"
                v-model="formData.employee_ids"
                :required="true"
                :chooseLabel="$t('employee')"
                :error-message="$errorMessage(errors, 'employee_ids')"
                :fetch-url="employee_url"
            />
            <app-form-group
                type="textarea"
                v-model="formData.remark"
                :label="$t('remark')"
                :placeholder="$textAreaPlaceHolder('remark')"
                :required="false"
                :error-message="$errorMessage(errors, 'remark')">
            </app-form-group>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {formatDateForServer} from "../../../../../common/Helper/Support/DateTimeHelper";
import moment from "moment";

export default {
    name  : "HotelFloorAssignmentCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            room_url    : null,
            employee_url: null,
            formData    : {},
        }
    },
    watch: {
        'formData.hotel_id': {
            handler  : function (hotel_id) {
                this.room_url = `${TENANT_BASE_URL}selectable/hotel/room?group=floor&hotel_id=${typeof hotel_id !== "undefined" ? hotel_id : 0}`
            },
            immediate: true
        },
        'formData.work_date': {
            handler  : function (work_date) {
                if (work_date) {
                    const url = `${TENANT_BASE_URL}selectable/hotel/floor-assignment/users?work_date=${formatDateForServer(work_date)}`;
                    this.employee_url = url;

                    // Fetch employee list and remove selected employees not in the new list
                    if (this.formData.employee_ids && this.formData.employee_ids.length) {
                        axiosGet(url).then(({data}) => {
                            const validIds = data.map(u => u.id);
                            this.formData.employee_ids = this.formData.employee_ids.filter(id => validIds.includes(id));
                        });
                    }
                }
            },
            immediate: true
        },
    },
    methods: {
        submitData() {
            this.loading = true;
            this.formData.work_date = this.formData.work_date ? formatDateForServer(this.formData.work_date) : '';

            let url  = this.$refs.form.dataset["url"];
            let data = {...this.formData};

            if (this.selectedUrl) {
                this.submitFromFixin('patch', url, data);
            } else {
                this.submitFromFixin('post', url, data);
            }
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#hotel-floor-assignment-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'hotel-floor-assignment-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            const data = response.data;
            if (data.hotel_id) {
                this.room_url = `${TENANT_BASE_URL}selectable/hotel/room?group=floor&hotel_id=${data.hotel_id}`;
            }
            if (data.work_date) {
                this.employee_url = `${TENANT_BASE_URL}selectable/hotel/floor-assignment/users?work_date=${data.work_date}`;
            }

            // Save employee_ids and remove from data temporarily
            let employeeIds = [];
            if (data.employee_ids && Array.isArray(data.employee_ids)) {
                employeeIds = data.employee_ids.map(id => parseInt(id));
            }
            data.employee_ids = [];
            this.formData = data;

            // Set employee_ids after the multi-select list has loaded
            setTimeout(() => {
                this.$set(this.formData, 'employee_ids', employeeIds);
            }, 1000);
        },
    },
}
</script>
